import { Map } from 'immutable';

import {
  CHECKOUT_PREVIEW,
  CHECKOUT_PURCHASE,
  FETCH_ACCOUNT,
  FETCH_RECURLY_TOKEN,
  INITIALIZE,
  PAYMENT_INFO_SAVED,
  PAYMENT_METHOD_CHANGED,
  RECURLY_COMPONENT_FETCH,
  RECURLY_COMPONENT_READY,
  RESET_COUPON_CODE,
  SAVE_COUPON_CODE,
  UPDATE_ACCOUNT,
} from './types';
import { ORDER_PLAN } from '../order/types';

const initialState = Map({
  couponCode: null,
  email: null,
  initialized: false,
  isLoading: true,
  paymentInfo: null,
  paymentInfoCurrent: null,
  paymentMethod: null,
  paymentMethodCurrent: null,
  previewResponse: {
    discount: 0,
    subtotal: 0,
    total: 0,
    tax: 0,
  },
  purchaseResponse: {
    subscription_ids: [],
    invoices_ids: [],
  },
  token: '',
});

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_RECURLY_TOKEN.SUCCESS:
      return state.withMutations((newState) => {
        newState
          .set('token', payload.id)
          .set('isLoading', false);
      });
    case FETCH_RECURLY_TOKEN.FAILURE:
      return state.withMutations((newState) => {
        newState
          .set('isLoading', false)
          .set('token', initialState.get('token'));
      });
    case RECURLY_COMPONENT_READY:
      return state.set('isLoading', false);
    case PAYMENT_INFO_SAVED:
      return state.withMutations((newState) => {
        newState
          .set('paymentInfoCurrent', payload.billing_info)
          .set('email', payload.email);
      });
    case PAYMENT_METHOD_CHANGED:
      return state.set('paymentMethodCurrent', payload);
    case CHECKOUT_PREVIEW.SUCCESS:
      return state.withMutations((newState) => {
        newState
          .set('previewResponse', payload)
          .set('isLoading', false);
      });
    case CHECKOUT_PREVIEW.FAILURE:
      return state.withMutations((newState) => {
        newState
          .set('isLoading', false)
          .set('previewResponse', initialState.get('previewResponse'));
      });
    case ORDER_PLAN:
      return state.set('previewResponse', initialState.get('previewResponse'));
    case CHECKOUT_PURCHASE.SUCCESS:
      return state.withMutations((newState) => {
        newState
          .set('purchaseResponse', payload)
          .set('isLoading', false);
      });
    case CHECKOUT_PURCHASE.FAILURE:
      return state.withMutations((newState) => {
        newState
          .set('isLoading', false)
          .set('purchaseResponse', initialState.get('purchaseResponse'));
      });
    case UPDATE_ACCOUNT.SUCCESS:
    case FETCH_ACCOUNT.SUCCESS: {
      const {
        billing_info: {
          address: {
            street1: address1,
            street2: address2,
            city,
            country,
            region,
            postal_code: postalCode,
          },
          first_name: firstName,
          last_name: lastName,
          company,
          vat_number: vatNumber,
          card_type: cardType,
          last_four: lastFour,
          exp_month: expMonth,
          exp_year: expYear,
        },
        email,
      } = payload;
      const paymentInfo = {
        firstName,
        lastName,
        email,
        company,
        vatNumber,
        address1,
        address2,
        city,
        country,
        postalCode,
        state: region,
      };
      const paymentMethod = {
        cardType,
        lastFour,
        expires: `${expMonth.toString().padStart(2, '0')}/${expYear}`,
        isValid: true,
      };
      return state.withMutations((newState) => {
        newState.set('paymentInfo', paymentInfo)
          .set('paymentInfoCurrent', null)
          .set('email', email)
          .set('paymentMethod', paymentMethod)
          .set('paymentMethodCurrent', null)
          .set('isLoading', false);
      });
    }
    case UPDATE_ACCOUNT.FAILURE:
      return state.set('isLoading', false);
    case FETCH_ACCOUNT.FAILURE:
      return state.withMutations((newState) => {
        newState.set('paymentInfo', initialState.get('paymentInfo'))
          .set('paymentMethod', initialState.get('paymentMethod'))
          .set('email', initialState.get('email'))
          .set('isLoading', false);
      });
    case SAVE_COUPON_CODE:
      return state.set('couponCode', payload);
    case RESET_COUPON_CODE:
      return state.set('couponCode', initialState.get('couponCode'));
    case RECURLY_COMPONENT_FETCH:
    case FETCH_RECURLY_TOKEN.REQUEST:
    case CHECKOUT_PREVIEW.REQUEST:
    case CHECKOUT_PURCHASE.REQUEST:
    case UPDATE_ACCOUNT.REQUEST:
      return state.set('isLoading', true);
    case INITIALIZE:
      return state.set('initialized', true);
    default:
      return state;
  }
};
